export default __webpack_public_path__ + "static/media/premium_plan_card.4ebcf808.png";